
<div class="footer-content">
    <div class="row">
        <div class="col-md-6">
            <p class="copy">
                &copy; Copyright <time class="year"></time> Project Informatica SRL - All Rights Reserved
            </p>
        </div>
        <div class="col">
            <div class="pc-version">
                v 1.20
            </div>
        </div>
    </div>
</div>